import { VolumeUnit } from '@trimble/types';
import { METRIC, INT_SURVEY, US_SURVEY } from './conversion-constants';
import { BaseConverterProps } from './base-converter-props.types';
import { UnreachableCaseError } from 'ts-essentials';

export const mapToMeters = ({
  value,
  baseUnit,
}: BaseConverterProps<number, VolumeUnit>): number | null => {
  const orderOfMagnitude = 3; // Volume units are cubed length units

  switch (baseUnit) {
    case 'mm3':
      return value * Math.pow(METRIC.SCALE.milliToBase, orderOfMagnitude);
    case 'cm3':
      return value * Math.pow(METRIC.SCALE.centiToBase, orderOfMagnitude);
    case 'm3':
      return value;
    case 'km3':
      return value * Math.pow(METRIC.SCALE.kiloToBase, orderOfMagnitude);
    case 'in3':
      return value * INT_SURVEY.VOLUME.cubicInchesToCubicMeters;
    case 'ft3':
      return value * INT_SURVEY.VOLUME.cubicFeetToCubicMeters;
    case 'yd3':
      return value * INT_SURVEY.VOLUME.cubicYardsToCubicMeters;
    case 'sIn3':
      return value * US_SURVEY.VOLUME.cubicInchesToCubicMeters;
    case 'sFt3':
      return value * US_SURVEY.VOLUME.cubicFeetToCubicMeters;
    case 'sYd3':
      return value * US_SURVEY.VOLUME.cubicYardsToCubicMeters;
    default:
      throw new UnreachableCaseError(baseUnit);
  }
};
